<script lang="ts">
	import type { StatusLabelType } from './StatusLabelType'
	import { StatusType } from './StatusType'
	import { _ } from '@repo/i18n'

	interface Props {
		status: StatusLabelType
		subStatus?: StatusLabelType
		big?: boolean
		additionalText?: any
		children?: import('svelte').Snippet
	}

	let { status, subStatus = null, big = false, additionalText = null, children }: Props = $props()
</script>

<div
	class="
    inline-flex items-center py-0.5
    whitespace-nowrap
    {subStatus ? 'rounded-l-md' : 'rounded-md'}
    {big ? 'px-2' : 'px-1 text-xs'}
    {status.type === StatusType.Success
		? 'bg-green-50 text-green-600 dark:bg-green-900 dark:text-green-200'
		: ''}
    {status.type === StatusType.Error
		? 'bg-red-50 text-red-600 dark:bg-red-900 dark:text-red-200'
		: ''}
    {status.type === StatusType.Warning
		? 'bg-yellow-50 text-yellow-600 dark:bg-yellow-900 dark:text-yellow-200'
		: ''}
    {status.type === StatusType.Pending
		? 'bg-blue-50 text-blue-600 dark:bg-blue-900 dark:text-blue-200'
		: ''}
    {status.type === StatusType.Inactive
		? 'bg-gray-50 text-gray-600 dark:bg-gray-900 dark:text-gray-200'
		: ''}
  "
>
	{#if children}{@render children()}{:else}
		{$_(status.label)}
		{additionalText || ''}
	{/if}
</div>

{#if subStatus}
	<div
		class="
    inline-flex rounded-r-md px-1 py-0.5 whitespace-nowrap
    {big ? '' : 'text-xs'}
    {subStatus.type === StatusType.Success
			? 'bg-green-100/20 text-green-400 dark:bg-green-700 dark:text-green-200'
			: ''}
    {subStatus.type === StatusType.Error
			? 'bg-red-100/20 text-red-400 dark:bg-red-700 dark:text-red-200'
			: ''}
    {subStatus.type === StatusType.Warning
			? 'bg-yellow-100/20 text-yellow-400 dark:bg-yellow-700 dark:text-yellow-200'
			: ''}
    {subStatus.type === StatusType.Pending
			? 'bg-blue-100/20 text-blue-400 dark:bg-blue-700 dark:text-blue-200'
			: ''}
    {subStatus.type === StatusType.Inactive
			? 'bg-gray-100/20 text-gray-400 dark:bg-gray-700 dark:text-gray-200'
			: ''}
  "
	>
		{$_(subStatus.label)}
	</div>
{/if}
